import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="w-full h-screen flex flex-col items-center justify-center bg-background text-foreground relative overflow-hidden">
        <span className="absolute w-[40vw] h-[40vw] bg-white/10 blur-[120px] rounded-full top-1/4 left-1/3 animate-pulse" />
        <span className="absolute w-[30vw] h-[30vw] bg-white/5 blur-[100px] rounded-full bottom-1/4 right-1/3 animate-pulse delay-300" />

        <div className="relative flex flex-col items-center justify-center z-10">
          <div className="size-20 border-[3px] border-white/20 border-t-accent rounded-full animate-spin mb-6"></div>
          <h2 className="text-lg tablet:text-xl font-medium text-white/80 animate-pulse">
            در حال بررسی ورود...
          </h2>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
}